



























































import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import { FetchState } from "@/shared/types";
import { Validator } from "vee-validate";
import moment from "moment";
import ContributionsNavigation from "@/employer/components/profile/ContributionsNavigation.vue";
import EmployeeBankInfoReport from "@/employer/components/reports/EmployeeBankInfoReport.vue";
import { useUserStore } from "@/shared/store/user";
import { usePayrollReportStore } from "@/employer/store/payrollReport";

@Component({
  components: {
    ContributionsNavigation,
    EmployeeBankInfoReport
  }
})
export default class PayrollReport extends Vue {
  @Prop({ required: false })
  hideHeader: boolean;

  $validator: Validator;

  userStore = useUserStore();
  reportStore = usePayrollReportStore();

  get isLoaded () {
    return this.reportStore.fetchLoadState === FetchState.Loaded;
  }

  mounted (): void {
    if (this.reportStore.automatedFundingLeaveDateFetchState !== FetchState.Loaded) {
      this.reportStore.getAutomatedFundingOptionLeaveDate(this.userStore.employerId);
    }
  }

  @Watch("reportStore.automatedFundingLeaveDateFetchState")
  onSignatureFetchStateChange () {
    if (this.reportStore.automatedFundingLeaveDateFetchState === FetchState.Loaded) {
      this.reportStore.getPayrollReportDates({
        employerId: this.userStore.employerId,
        automatedLeaveDate: this.reportStore.automatedFundingLeaveDate
      });
    }
  }

  get payrollCutOffDate () {
    return moment(this.reportStore.nextPayrollCutoffDate).format("YYYY-MM-DD");
  }

  isDateInPast (payDate: string): boolean {
    return moment(payDate, "YYYY-MM-DD").diff(moment().format("YYYY-MM-DD"), "days") <= 0;
  }

  downloadChangeReport (payDate: string) {
    this.reportStore.processPayrollChangeReport({ employerId: this.userStore.employerId, payrollDate: payDate });
  }

  downloadFullReport (payDate: string) {
    this.reportStore.processPayrollReport({ employerId: this.userStore.employerId, payrollDate: payDate });
  }

  get displayReportButton () {
    return this.$route.query.bend2661;
  }
}
